function initCloserLookMedia(root) {
  root.querySelectorAll('.closer-look-media').forEach(function (media) {
    if (media.dataset.closerLookInit) return;
    media.dataset.closerLookInit = 'true';

    var video = media.querySelector('.closer-look-video');
    if (!video) return;

    var watchBtn = media.querySelector('.closer-look-watch-btn');
    var toggleBtn = media.querySelector('.closer-look-toggle-btn');
    var left = media.closest('.closer-look-left');
    var mobileLink = left ? left.querySelector('.closer-look-mobile-watch-link') : null;

    function playVideo() {
      media.classList.add('is-playing');
      video.play();
    }

    [watchBtn, mobileLink].forEach(function (btn) {
      if (btn) btn.addEventListener('click', playVideo);
    });

    function togglePlay() {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', togglePlay);
    }

    video.addEventListener('click', togglePlay);

    video.addEventListener('play', function () {
      media.classList.add('is-playing');
      media.classList.add('is-video-playing');
    });

    video.addEventListener('pause', function () {
      media.classList.remove('is-video-playing');
    });

    video.addEventListener('ended', function () {
      media.classList.remove('is-playing');
      media.classList.remove('is-video-playing');
      video.currentTime = 0;
    });
  });
}

function initCloserLookFaqs(root) {
  root.querySelectorAll('.closer-look-faq-item').forEach(function (item) {
    var question = item.querySelector('.closer-look-faq-question');
    var answer = item.querySelector('.closer-look-faq-answer');
    if (!question || !answer || item.dataset.closerLookFaqInit) return;
    item.dataset.closerLookFaqInit = 'true';

    question.addEventListener('click', function () {
      var list = item.closest('.closer-look-faq-list');
      var isOpen = item.classList.contains('is-open');

      if (list) {
        list.querySelectorAll('.closer-look-faq-item').forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            other.querySelector('.closer-look-faq-answer').style.maxHeight = null;
          }
        });
      }

      if (isOpen) {
        item.classList.remove('is-open');
        answer.style.maxHeight = null;
      } else {
        item.classList.add('is-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
}

function initCloserLook(root) {
  initCloserLookMedia(root);
  initCloserLookFaqs(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initCloserLook(document);
  });
} else {
  initCloserLook(document);
}

document.addEventListener('shopify:section:load', function (event) {
  initCloserLook(event.target);
});
